// extracted by mini-css-extract-plugin
export default {"Message":"Message_Message__1i+hT","Container":"Message_Container__0POwT"};